"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.308 5.935c-1.04-1.63.73-3.591 2.457-2.728l14.184 7.09c1.404.701 1.404 2.704 0 3.406l-14.184 7.09c-1.727.863-3.497-1.098-2.457-2.728L7.18 12zM5.14 4.459c-.46-.229-.926.292-.652.723l3.905 6.117a1.3 1.3 0 0 1 0 1.401l-3.905 6.118c-.274.43.192.951.652.722l14.183-7.09a.504.504 0 0 0 0-.901z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=SendIcon24.js.map